// @flow
import ABOUT_THE_DATA from "./about-the-data/config";
import MULTIMEDIA_GALLERY from "./multimedia-gallery/config";
import AUDIO_QUOTES from "./audio-quotes/config";
import AWARDS_EMBED from "./awards-embed/config";
import BEFORE_AFTER_IMAGE_SLIDER from "./before-after-image-slider/config";
import BIG_NUMBERS from "./big-numbers/config";
import BUSHFIRE_HOT_SPOTS from "./bushfire-hot-spots/config";
import CHAT_MODULE from "./chat-module/config";
import COLLAPSIBLE_PROFILE from "./collapsible-profile/config";
import CONTENT_CARD from "./content-card/config";
import CRIME_LAUNCH_PAD from "./crime-launch-pad/config";
import CRIME_POSTCODE_MAP from "./crime-postcode-map/config";
import CRIME_SPOTLIGHT from "./crime-spotlight/config";
import CRIME_TREEMAP from "./crime-treemap/config";
//import DISTANCE_BUBBLE_MAP from "./distance-bubble-map/config";
import DATAWRAPPER_EMBED from "./datawrapper-embed/config";
import DATAWRAPPER_EMBED_LEGACY from "./datawrapper-embed-legacy/config";
import DEBATE_MODULE from "./debate-module/config";
import ELECTION_SEAT_FINDER_EMBED from "./election-seat-finder/config";
import EXTERNAL_CONTENT_EMBED from "./external-content-embed/config";
import FREQUENTLY_ASKED_QUESTION from "./frequently-asked-questions/config";
import FACT_CHECK from "./fact-check/config";
import FLOURISH_EMBED from "./flourish-embed/config";
import GOOD_WEEKEND_QUIZ from "./good-weekend-quiz/config";
import GRAPHIC_EMBED from "./graphic-embed/config";
import GUESSTIMATOR from "./guesstimator/config";
import HEADER_MODULE from "./header-module/config";
import READER_POLL from "./reader-poll/config";
import LIVE_BUSHFIRE_MAP from "./live-bushfire-map/config";
import LIVE_WIND_RAIN_RADAR_MAP from "./live-wind-rain-radar-air-quality-map/config";
import LIVE_FIRE_DANGER_RATINGS_MAP from "./live-fire-danger-ratings-map/config";
import MEDIA_WALL from "./media-wall/config";
import MATCH_PREDICTOR from "./match-predictor/config";
import NEUTRAL_QUIZ from "./neutral-quiz/config";
import NEWS_TIP_POINTER from "./news-tip-pointer/config";
import PDFVIEWER from "./pdf-viewer/config";
import PODCAST_POINTER from "./podcast-pointer/config";
import IMAGE_BAR_GALLERY from "./image-bar-gallery/config";
import IMAGE_QUOTE from "./image-quote/config";
import PEOPLE_GALLERY from "./people-gallery/config";
import PEOPLE_GALLERY_EXTENDED from "./people-gallery-extended/config";
import PHOTO_GALLERY from "./photo-gallery/config";
import POLITICAL_MONITOR from "./political-monitor/config";
import PROFILE_EMBED from "./profile-embed/config";
import TEAROUT_EXCERPT from "./tearout-excerpt/config";
import TIMELINE from "./timeline/config";
import MULTIMEDIA_TIMELINE from "./multimedia-timeline/config";
import TIPSTAR from "./tipstar/config";
import TECH_REVIEW from "./tech-review/config";
import TRAVELLER_QUIZ from "./traveller-quiz/config";
import SUPER_QUIZ from "./super-quiz/config";
import US_VOTES2020_STATE_RESULTS from "./us-votes2020-state-results/config";
import VIDEO_LOOP from "./video-loop/config";
import WEATHER_WIDGET from "./weather-widget/config";
import GOOGLE_FORM_EMBEDDER from "./google-form-embedder/config";
import POWER_OUTAGE_EMBED from "./power-outage-embed/config";
import type { Breadcrumb } from "app/components/atoms/Breadcrumbs/Breadcrumbs";
import type { GridMenuBodyItemConfig } from "app/components/molecules/GridMenuBody/GridMenuBody";
import type { Component } from "react";

export type InteractiveAuthor = {
  name: string,
  image: string,
  link: string
};

export type InteractivesMenuItemConfig = GridMenuBodyItemConfig & {
  author?: InteractiveAuthor,
  ConfigComponent: Function | Component<Object, Object>,
  cradleIframeUrlRoot?: string,
  iframedConfigToolUrl?: string,
  iframedConfigToolCanBeResized?: boolean,
  groupsWithAccess: Array<string>
};

const INTERACTIVES_LIST: Array<InteractivesMenuItemConfig> = [
  GRAPHIC_EMBED,
  ABOUT_THE_DATA,
  MULTIMEDIA_GALLERY,
  AUDIO_QUOTES,
  AWARDS_EMBED,
  BEFORE_AFTER_IMAGE_SLIDER,
  BIG_NUMBERS,
  BUSHFIRE_HOT_SPOTS,
  CHAT_MODULE,
  COLLAPSIBLE_PROFILE,
  CONTENT_CARD,
  CRIME_LAUNCH_PAD,
  CRIME_POSTCODE_MAP,
  CRIME_SPOTLIGHT,
  CRIME_TREEMAP,
  DATAWRAPPER_EMBED,
  DATAWRAPPER_EMBED_LEGACY,
  DEBATE_MODULE,
  //DISTANCE_BUBBLE_MAP,
  ELECTION_SEAT_FINDER_EMBED,
  EXTERNAL_CONTENT_EMBED,
  FREQUENTLY_ASKED_QUESTION,
  FACT_CHECK,
  FLOURISH_EMBED,
  GOOD_WEEKEND_QUIZ,
  GUESSTIMATOR,
  HEADER_MODULE,
  LIVE_BUSHFIRE_MAP,
  LIVE_WIND_RAIN_RADAR_MAP,
  LIVE_FIRE_DANGER_RATINGS_MAP,
  MEDIA_WALL,
  MATCH_PREDICTOR,
  NEUTRAL_QUIZ,
  NEWS_TIP_POINTER,
  IMAGE_BAR_GALLERY,
  PODCAST_POINTER,
  IMAGE_QUOTE,
  PEOPLE_GALLERY,
  PEOPLE_GALLERY_EXTENDED,
  PHOTO_GALLERY,
  PDFVIEWER,
  POLITICAL_MONITOR,
  PROFILE_EMBED,
  READER_POLL,
  TEAROUT_EXCERPT,
  TIMELINE,
  MULTIMEDIA_TIMELINE,
  TIPSTAR,
  TECH_REVIEW,
  TRAVELLER_QUIZ,
  SUPER_QUIZ,
  VIDEO_LOOP,
  US_VOTES2020_STATE_RESULTS,
  WEATHER_WIDGET,
  GOOGLE_FORM_EMBEDDER,
  POWER_OUTAGE_EMBED
];

export const DUMMY_INTERACTIVES_LIST = [
  {
    application_id: "about-the-data",
    application_name: "About the data",
    application_groups_with_access: "admin_user",
    application_watch: true
  },
  {
    application_id: "multimedia-gallery",
    application_name: "Multimedia gallery",
    application_groups_with_access: "specialist_user",
    application_watch: true
  },
  {
    application_id: "audio-quotes",
    application_name: "Audio quotes",
    application_groups_with_access: "admin_user",
    application_watch: false
  },
  {
    application_id: "awards-embed",
    application_name: "Awards embed",
    application_groups_with_access: "admin_user",
    application_watch: true
  },
  {
    application_id: "big-numbers",
    application_name: "Big numbers",
    application_groups_with_access: "admin_user",
    application_watch: false
  },
  {
    application_id: "chat-module",
    application_name: "Chat module",
    application_groups_with_access: "admin_user",
    application_watch: true
  },
  {
    application_id: "collapsible-profile",
    application_name: "Collapsible profile",
    application_groups_with_access:
      "specialist_user, editor_user,  standard_user",
    application_watch: true
  },
  {
    application_id: "content-card",
    application_name: "Content card",
    application_groups_with_access: "admin_user"
  },
  {
    application_id: "crime-launch-pad",
    application_name: "Crime launch pad",
    application_groups_with_access: "specialist_user",
    application_watch: false
  },
  {
    application_id: "crime-spotlight",
    application_name: "Crime spotlight",
    application_groups_with_access:
      "specialist_user, editor_user,  standard_user"
  },
  {
    application_id: "election-seat-finder",
    application_name: "Election seat finder",
    application_groups_with_access:
      "specialist_user, editor_user,  standard_user"
  },
  {
    application_id: "reader-poll",
    application_name: "Reader poll",
    application_groups_with_access:
      "specialist_user, editor_user, standard_user",
    application_watch: false
  },
  {
    application_id: "guesstimator",
    application_name: "Guesstimator",
    application_groups_with_access: "admin_user",
    application_watch: false
  },
  {
    application_id: "distance-bubble-map",
    application_name: "Distance Bubble Map",
    application_groups_with_access:
      "specialist_user, editor_user, standard_user",
    application_watch: false
  },
  {
    application_id: "video-loop",
    application_name: "Video loop",
    application_groups_with_access:
      "specialist_user, editor_user, standard_user",
    application_watch: false
  },
  {
    application_id: "timeline",
    application_name: "Timeline",
    application_groups_with_access:
      "specialist_user, editor_user, standard_user",
    application_watch: false
  },
  {
    application_id: "multimedia-timeline",
    application_name: "Multimedia Timeline",
    application_groups_with_access:
      "specialist_user, editor_user, standard_user",
    application_watch: false
  },
  {
    application_id: "frequently-asked-questions",
    application_name: "Frequently-asked questions",
    application_groups_with_access:
      "specialist_user, editor_user, standard_user",
    application_watch: false
  },
  {
    application_id: "fact-check",
    application_name: "Fact-check embed",
    application_groups_with_access:
      "specialist_user, editor_user, standard_user",
    application_watch: false
  },
  {
    application_id: "tipstar",
    application_name: "Tipstar",
    application_groups_with_access:
      "specialist_user, editor_user, standard_user",
    application_watch: false
  },
  {
    application_id: "tech-review",
    application_name: "Tech Review",
    application_groups_with_access: "admin_user",
    application_watch: false
  },
  {
    application_id: "tearout-excerpt",
    application_name: "Tearout excerpt",
    application_groups_with_access:
      "specialist_user, editor_user, standard_user",
    application_watch: false
  },
  {
    application_id: "before-after-image-slider",
    application_name: "Before-after image slider",
    application_groups_with_access:
      "specialist_user, editor_user, standard_user",
    application_watch: false
  },
  {
    application_id: "people-gallery",
    application_name: "People gallery",
    application_groups_with_access:
      "specialist_user, editor_user, standard_user",
    application_watch: false
  },
  {
    application_id: "people-gallery-extended",
    application_name: "People gallery extended",
    application_groups_with_access:
      "specialist_user, editor_user, standard_user",
    application_watch: false
  },
  {
    application_id: "pdf-viewer",
    application_name: "PDF viewer",
    application_groups_with_access:
      "specialist_user, editor_user, standard_user",
    application_watch: false
  },
  {
    application_id: "user-management-console",
    application_name: "User-management console",
    application_groups_with_access:
      "specialist_user, editor_user, standard_user",
    application_watch: false
  },
  {
    application_id: "traveller-quiz",
    application_name: "Traveller quiz",
    application_groups_with_access:
      "specialist_user, editor_user, standard_user",
    application_watch: true
  },
  {
    application_id: "photo-gallery",
    application_name: "Photo gallery",
    application_groups_with_access:
      "specialist_user, editor_user, standard_user",
    application_watch: true
  },
  {
    application_id: "good-weekend-quiz",
    application_name: "Good Weekend quiz",
    application_groups_with_access:
      "specialist_user, editor_user, standard_user",
    application_watch: true
  },
  {
    application_id: "graphic-embed",
    application_name: "Graphic embed",
    application_groups_with_access:
      "specialist_user, editor_user, standard_user",
    application_watch: true
  },
  {
    application_id: "live-bushfire-map",
    application_name: "Live Bushfire Map",
    application_groups_with_access: "specialist_user, editor_user",
    application_watch: true
  },
  {
    application_id: "live-fire-danger-ratings-map",
    application_name: "Live Fire Danger Ratings Map",
    application_groups_with_access: "specialist_user, editor_user",
    application_watch: true
  },
  {
    application_id: "live-wind-rain-radar-map",
    application_name: "Live Wind & Rain radar Map",
    application_groups_with_access: "specialist_user, editor_user",
    application_watch: true
  },
  {
    application_id: "super-quiz",
    application_name: "Super quiz",
    application_groups_with_access:
      "specialist_user, editor_user, standard_user",
    application_watch: true
  },
  {
    application_id: "image-quote",
    application_name: "Image quote",
    application_groups_with_access:
      "specialist_user, editor_user, standard_user",
    application_watch: true
  },
  {
    application_id: "imagebar-gallery",
    application_name: "Image-bar gallery",
    application_groups_with_access:
      "specialist_user, editor_user, standard_user",
    application_watch: true
  },
  {
    application_id: "crime-treemap",
    application_name: "Crime Treemap",
    application_groups_with_access:
      "specialist_user, editor_user, standard_user",
    application_watch: true
  },
  {
    application_id: "crime-postcode-map",
    application_name: "Crime Postcode Map",
    application_groups_with_access:
      "specialist_user, editor_user, standard_user",
    application_watch: ""
  },
  {
    application_id: "datawrapper-embed",
    application_name: "Datawrapper Embed v2.0",
    application_groups_with_access: "standard_user",
    application_watch: ""
  },
  {
    application_id: "datawrapper-embed-legacy",
    application_name: "Datawrapper Embed",
    application_groups_with_access: "standard_user",
    application_watch: ""
  },
  {
    application_id: "debate-module",
    application_name: "Debate Module",
    application_groups_with_access: "standard_user",
    application_watch: ""
  },
  {
    application_id: "external-content-embed",
    application_name: "External content Embed",
    application_groups_with_access: "admin_user",
    application_watch: ""
  },
  {
    application_id: "flourish-embed",
    application_name: "Flourish Embed",
    application_groups_with_access: "standard_user",
    application_watch: ""
  },
  {
    application_id: "test",
    application_name: "Test application",
    application_groups_with_access:
      "specialist_user, editor_user, standard_user",
    application_watch: ""
  },
  {
    application_id: "bushfire-hot-spots",
    application_name: "Bushfire Hot Spots",
    application_groups_with_access: "specialist_user",
    application_watch: ""
  },
  {
    application_id: "political-monitor",
    application_name: "Political Monitor",
    application_groups_with_access: "specialist_user",
    application_watch: ""
  },
  {
    application_id: "media-wall",
    application_name: "Media wall",
    application_groups_with_access: "admin_user",
    application_watch: ""
  },
  {
    application_id: "match-predictor",
    application_name: "Match predictor",
    application_groups_with_access: "admin_user",
    application_watch: ""
  },
  {
    application_id: "neutral-quiz",
    application_name: "Neutral quiz",
    application_groups_with_access: "admin_user",
    application_watch: ""
  },
  {
    application_id: "profile-embed",
    application_name: "Profile embed",
    application_groups_with_access: "admin_user",
    application_watch: ""
  },
  {
    application_id: "google-form-embedder",
    application_name: "Google Form Embedder",
    application_groups_with_access: "admin_user, specialist_user, editor_user",
    application_watch: true
  },
  {
    application_id: "section-header",
    application_name: "Header module",
    application_groups_with_access: "admin_user",
    application_watch: ""
  },
  {
    application_id: "podcast-pointer",
    application_name: "Podcast pointer",
    application_groups_with_access: "admin_user",
    application_watch: ""
  },
  {
    application_id: "power-outage-embed",
    application_name: "Power Outage Embed",
    application_groups_with_access: "admin_user",
    application_watch: false
  }
];

export const DEFAULT_INTERACTIVE_CONFIG_PAGE_BREADCRUMBS: Array<Breadcrumb> = [
  { name: "Applications hub", link: "/hub" },
  { name: "Interactives", link: "/interactives" }
];

export async function getDummyInteractiveList(req, file, callback) {
  return await DUMMY_INTERACTIVES_LIST;
}

export default INTERACTIVES_LIST;
